import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ActivitiesCarousel.css';

import hortiImg from '../../assets/images/programs/horticulture/pic3.png';
import visitImg from '../../assets/images/programs/visit/pic.png';
import img4 from '../../assets/images/school/img4.png';
import maizeImg from '../../assets/images/programs/training/maize.png';
import img3 from '../../assets/images/school/img3.jpeg';
import coconutImg from '../../assets/images/programs/training/coconut.png';

const initialActivities = [
  {
    id: 1,
    image: hortiImg,
    title: 'Excellence in Agriculture',
    description: 'Founder Mr. Isaac Agyiri awarded Overall Best Agriculture Teacher of the Year and completed 4-month specialized Horticulture training in the Netherlands.',
    link: '/activity/1'
  },
  {
    id: 2,
    image: visitImg,
    title: 'Strategic Partnerships',
    description: 'Collaborating with the Director for Presidential Initiatives to advance national agricultural policy and agribusiness innovation.',
    link: '/activity/2'
  },
  {
    id: 3,
    image: img4,
    title: 'Twifo Heman SHS Training',
    description: 'Empowering students at Twifo Heman Senior High Technical School with hands-on skills in nursing and maintaining cabbage nurseries on beds.',
    link: '/activity/3'
  },
  {
    id: 4,
    image: maizeImg,
    title: 'Maize Cultivation Mastery',
    description: 'Training students at Hemang Senior High Technical School on the scientific and efficient application of fertilizer for maize crops.',
    link: '/activity/4'
  },
  {
    id: 5,
    image: img3,
    title: 'Transplanting with the Next Gen',
    description: 'A day of impact at Nduaem D/A Basic School Farm, where our team and students worked together to transplant cabbage seedlings.',
    link: '/activity/5'
  },
  {
    id: 6,
    image: coconutImg,
    title: 'Afforestation & Planet Care',
    description: 'Educating the next generation on the critical importance of afforestation and restoring our natural ecosystems.',
    link: '/activity/6'
  }
];

// Duplicate the array a few times to create a long track for seamless sliding
const extendedActivities = [
    ...initialActivities, 
    ...initialActivities, 
    ...initialActivities,
    ...initialActivities,
    ...initialActivities
];

const ActivitiesCarousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => {
                // When we reach near the end of our extended array, reset back to the beginning
                // to create an infinite loop effect. Since we duplicated it 5 times, it takes a long time.
                if (prevIndex >= initialActivities.length * 4) {
                    return 0; 
                }
                return prevIndex + 1;
            });
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <section className="activities-section">
            <div className="activities-container">
                <div className="activities-header">
                    <span className="pill-title">&bull; OUR CORE IMPACT</span>
                    <h2>Cultivating Sustainable Agriculture &<br/>Ecological Resilience.</h2>
                </div>
            </div>
            
            <div className="carousel-container">
                    <div 
                        className="carousel-track" 
                        style={{ '--current-index': currentIndex } as React.CSSProperties}
                    >
                        {extendedActivities.map((item, index) => (
                            <div className="carousel-card" key={`${item.id}-${index}`}>
                                <div className="card-image-bg" style={{ backgroundImage: `url(${item.image})` }}>
                                    <div className="card-overlay">
                                        <h3>{item.title}</h3>
                                        <div className="card-hover-content">
                                            <p>{item.description}</p>
                                            <Link to={item.link}>Join Our Work ↗</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
        </section>
    );
};

export default ActivitiesCarousel;
